import {isDevMode, Pipe, PipeTransform} from '@angular/core';
import {DatePipe} from '@angular/common';
import * as moment from 'moment';

@Pipe({
    name: 'myDate'
})
export class MyDatePipe implements PipeTransform {
    constructor(private pipe: DatePipe) {

    }

    public transform(value: Date | string, format: string): string | null {
        if (!value || !format) {
            return null;
        }

        try {
            const newDate = moment(value);

            if (moment()?.format('YYYYMMDD') === newDate?.format('YYYYMMDD')) {
                format = 'HH:mm';
            }

            return this.pipe.transform(value, format);
        } catch (e) {
            if (isDevMode()) {
                console.error(e);
            }
            return null;
        }

    }
}
